import React, { useState } from "react";

/**
 * Reusable newsletter form that composes an email to agricomassurance@gmail.com
 * using the user's default mail client (mailto: link). No backend needed.
 *
 * Styling matches existing forms on all pages.
 */
const NewsletterForm = () => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    // Basic email pattern (simple)
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      alert("Please enter a valid email address.");
      return;
    }
    setSending(true);

    const to = "agricomassurance@gmail.com";
    const subject = encodeURIComponent("Newsletter Subscription Request");
    const body = encodeURIComponent(
      `Hello Agricom Assurance,\n\nPlease add me to your newsletter.\n\nSubscriber email: ${trimmed}\n\nThank you.\n`
    );

    // Open default mail app with prefilled mail
    window.location.href = `mailto:${to}?subject=${subject}&body=${body}`;

    // Reset after a short delay (harmless UX tidy)
    setTimeout(() => setSending(false), 800);
  };

  return (
    <form className="flex w-full max-w-xl gap-3" onSubmit={handleSubmit}>
      <label htmlFor="newsletter-email" className="sr-only">Email</label>
      <input
        id="newsletter-email"
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="flex-1 rounded-full px-5 py-3 bg-white/10 placeholder-brand-100/80 focus:bg-white/20 outline-none"
        placeholder="Email"
        aria-label="Email address"
      />
      <button
        type="submit"
        disabled={sending}
        className="px-5 py-3 rounded-full bg-brand-accent text-white font-semibold hover:bg-brand-400 transition disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {sending ? "Opening…" : "Submit"}
      </button>
    </form>
  );
};

export default NewsletterForm;
